/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import AppBaseScreen from "../../components/AppBaseScreen";
import Rocket from "../../assets/logo/rocket.svg";
import {
  Box,
  Container,
  Divider,
  Grid,
  IconButton,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { withdrawStatusTheme } from "./theme";
import AppButton from "../../components/AppButton";
import { ContentCopy, Home, InfoOutlined } from "@mui/icons-material";
import { getWithdraw } from "../../store/api";
import {
  formatCryptoDecimals,
  formatNumber,
  getMerchantName,
  isFiatTransaction,
  trimText,
} from "../../utils";
import AppStatus from "../../components/AppStatus";
import { useDispatch } from "react-redux";
import { showMessageBar, updateFeedbackSurveyState } from "../../store/actions";
import { MESSAGE_BAR_TYPES } from "../../utils/constants";
import {
  TYPE_CREDIT,
  TYPE_DEBIT,
  TYPE_MERCHANT_RECLAIM,
} from "../../store/actions/actionTypes";
import AppToolTip from "../../components/AppTooltip";

export default function WithdrawDetail() {
  const params = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [withdrawData, setWithdrawData] = useState(null);

  useEffect(() => {
    if (params.id) {
      getWithdrawData(params.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const getWithdrawData = async (id) => {
    const resp = await getWithdraw(id);
    dispatch(updateFeedbackSurveyState(resp.result.showFeedback));

    setWithdrawData(resp.result);
  };
  const copyText = (text) => {
    try {
      navigator?.clipboard?.writeText(text);
      dispatch(
        showMessageBar(MESSAGE_BAR_TYPES.SUCCESS, t("ReferenceCopied"))
      );
    } catch (err) { }
  };
  const showFees = (data) => {
    if (data?.feeCharged?.hasOwnProperty('feeEnabled')) {
      return data?.feeCharged?.feeEnabled;
    }
    return true;
  }
  if (!withdrawData) {
    return (
      <AppBaseScreen isHeader={false}>
        <Box
          display={"flex"}
          flexDirection="column"
          justifyContent="center"
          alignItems={"center"}
          position={"absolute"}
          width="100%"
          height={"100%"}
          top={0}
          bottom={0}
          left={0}
        >
          <Box marginTop={10} marginBottom={20} marginLeft={"-84px"}>
            <Box className="spin" position={"absolute"}></Box>
            <Rocket style={{ width: 84, position: "absolute" }} />
          </Box>
          <Box>
            <Typography
              fontSize={16}
              textTransform={"capitalize"}
              color={"#F8FAFF"}
              textAlign={"center"}
            >
              {t("fetching transfer details")}
            </Typography>
            <AppButton
              buttontheme={"transparent"}
              startIcon={<Home />}
              title={t("BackDashboard")}
              onClick={() => navigate("/home")}
            />
          </Box>
        </Box>
      </AppBaseScreen>
    );
  }

  const getType = (type) => {
    switch (type) {
      case TYPE_CREDIT:
        return t("ReceivedCredit");
      case TYPE_DEBIT:
        return t("TransferDebit");
      case TYPE_MERCHANT_RECLAIM:
        return t("ReclaimDebit");
      default:
        return "---";
    }
  };
  return (
    <AppBaseScreen
      isHeader={true}
      backText={""}
      navigate={true}
      navigatePath={"/home"}
      headerTitle={t("Details")}
    >
      <ThemeProvider theme={withdrawStatusTheme}>
        <Container
          disableGutters
          sx={{
            display: "flex",
            flexFlow: "column",
            justifyContent: "flex-start",
            minHeight: "85vh",
            paddingLeft: 1,
            paddingRight: 1,
            paddingBottom: 2
          }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Typography fontSize={14} fontWeight={400}>
              {t("ReferenceId")}:
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography fontSize={14} textAlign={"center"} marginRight={1}>
                {withdrawData.id}
              </Typography>
              <IconButton onClick={() => copyText(withdrawData.id)}>
                <ContentCopy htmlColor="#F8FAFF" />
              </IconButton>
            </Box>

          </Box>
          <Box marginBottom={4} marginTop={6}>
            <Grid container sx={{ color: "#F8FAFF", rowGap: 2 }}>
              <Grid item xs={4}>
                <Typography fontSize={14} fontWeight={400}>
                  {t("type")}:
                </Typography>
              </Grid>
              <Grid item xs={8} textAlign="right">
                <Typography fontSize={14} fontWeight={400}>
                  {getType(withdrawData.type)}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography fontSize={14} fontWeight={400}>
                  {t("status")}:
                </Typography>
              </Grid>
              <Grid item xs={8} textAlign="right">
                <AppStatus status={withdrawData.status} />
              </Grid>
              <Grid item xs={4}>
                <Typography fontSize={14} fontWeight={400}>
                  {withdrawData.type === TYPE_DEBIT
                    ? t("Amount Requested")
                    : t("amount")}
                  :
                </Typography>
              </Grid>
              <Grid item xs={8} textAlign="right">
                <Typography fontSize={14} fontWeight={400}>
                  {formatNumber(withdrawData.amount)} {withdrawData.currency}
                </Typography>
              </Grid>
              {isFiatTransaction(withdrawData.service) && <>
                <Grid item xs={4}>
                  <Typography fontSize={14} fontWeight={400}>
                    Payment Method
                  </Typography>
                </Grid>
                <Grid item xs={8} textAlign="right">
                  <Typography fontSize={14} fontWeight={400}>
                    {withdrawData?.feeCharged?.paymentMethodDisplayName}
                  </Typography>
                </Grid>
              </>}
              {withdrawData?.cryptoCurrency?.fullTitle && (
                <>
                  <Grid item xs={5}>
                    <Typography fontSize={14} fontWeight={400}>
                      {t("selectPaymentBack")}:
                    </Typography>
                  </Grid>
                  <Grid item xs={7} textAlign="right" >
                    <Typography fontSize={14} fontWeight={400}>
                      {withdrawData?.cryptoCurrency?.id
                        ? `${withdrawData?.cryptoCurrency?.id}`
                        : ``}&nbsp;({
                        withdrawData?.cryptoNetwork.toUpperCase()
                      })
                    </Typography>
                  </Grid>
                </>
              )}

              {(withdrawData.type === TYPE_MERCHANT_RECLAIM ||
                withdrawData.type === TYPE_CREDIT) && (
                  <>
                    <Grid item xs={6}>
                      <Typography fontSize={14} fontWeight={400}>
                        {t("Merchant Name")}:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} textAlign="right">
                      <Typography fontSize={14} fontWeight={400}>
                        {getMerchantName(withdrawData.merchant)}
                      </Typography>
                    </Grid>
                  </>
                )}

              {(!isFiatTransaction(withdrawData.service) && !!withdrawData?.feeCharged?.processingFeeUsd && showFees(withdrawData)) && (
                <>
                  <Grid item xs={4}>
                    <Typography fontSize={14} fontWeight={400}>
                      {t("processing-fee")}:
                    </Typography>
                  </Grid>
                  <Grid item xs={8} textAlign="right">
                    <Typography fontSize={14} fontWeight={400}>
                      {withdrawData.feeCharged.processingFeeUsd} USD {(withdrawData.feeCharged.processingFeePercent != 0) ? `+ ${withdrawData.feeCharged.processingFeePercent}%` : ""}
                    </Typography>
                  </Grid>
                </>
              )}

              {(isFiatTransaction(withdrawData.service) && !!withdrawData?.feeCharged?.processingFeePercent && showFees(withdrawData)) && (
                <>
                  <Grid item xs={4}>
                    <Typography fontSize={14} fontWeight={400}>
                      {t("processing-fee")}:
                    </Typography>
                  </Grid>
                  <Grid item xs={8} textAlign="right">
                    <Typography fontSize={14} fontWeight={400}>
                      {withdrawData.feeCharged.processingFeeFlatUsd} USD {(withdrawData.feeCharged.processingFeePercent != 0 && withdrawData?.feeCharged?.processingFeePercent) ? `+ ${withdrawData.feeCharged.processingFeePercent}%` : ""}
                    </Typography>
                  </Grid>
                </>
              )}
              {!!withdrawData?.feeCharged?.networkFeeUsd && (
                <>
                  <Grid item xs={4}>
                    <Typography fontSize={14} fontWeight={400}>
                      {t("Network fees")}:
                    </Typography>
                  </Grid>
                  <Grid item xs={8} textAlign="right">
                    <Typography fontSize={14} fontWeight={400}>
                      {withdrawData.feeCharged.networkFeeUsd}{" "}
                      USD
                    </Typography>
                  </Grid>
                </>
              )}
              {(!isFiatTransaction(withdrawData.service) && !!withdrawData?.feeCharged?.processingFeeUsd) && (<>
                <Grid item xs={4}>
                  <Typography fontSize={14} fontWeight={400}>
                    {t("Amount to be sent")}:
                  </Typography>
                </Grid>
                <Grid item xs={8} textAlign="right">
                  <Typography fontSize={14} fontWeight={400}>
                    {formatNumber(Number(withdrawData.amount) - Number(withdrawData.feeCharged.processingFeeUsd) - Number(withdrawData.feeCharged.processingFeePercentUsd))}{" "}
                    USD
                  </Typography>
                </Grid>
              </>)}
              {(isFiatTransaction(withdrawData.service) && !!withdrawData?.feeCharged) && <> <Grid
                item
                xs={6}
              >
                <Typography
                  fontSize={14}
                  fontWeight={400}
                >
                  {t("Amount To Be Sent")}:
                </Typography>
              </Grid>
                <Grid
                  item
                  xs={6}
                >
                  <Typography
                    fontSize={14}
                    textAlign="right"
                    fontWeight={400}
                  >
                    {withdrawData?.feeCharged?.payoutAmountUsd} USD
                  </Typography>
                </Grid></>}
              {!!withdrawData?.feeCharged?.cryptoCurrencyCurrentRate && (
                <>
                  <Grid item xs={4}>
                    <Typography fontSize={14} fontWeight={400}>
                      {t("exchangeRate")}
                    </Typography>
                  </Grid>
                  <Grid item xs={8} textAlign="right">
                    <Typography fontSize={14} fontWeight={400}></Typography>

                    <Typography fontSize={14} fontWeight={400}>
                      1 {withdrawData.cryptoCurrency.id} ={" "}
                      {formatCryptoDecimals(
                        withdrawData.feeCharged.cryptoCurrencyCurrentRate
                      )}
                      &nbsp;
                      {withdrawData?.currency}
                      &nbsp;
                    </Typography>
                  </Grid>
                </>
              )}
              {!!withdrawData?.feeCharged?.rkflRate && (
                <>
                  <Grid item xs={4}>
                    <Typography fontSize={14} fontWeight={400}>
                      {t("exchangeRate")}
                    </Typography>
                  </Grid>
                  <Grid item xs={8} textAlign="right">
                    <Typography fontSize={14} fontWeight={400}></Typography>

                    <Typography fontSize={14} fontWeight={400}>
                      <span>1 USD =  </span>
                      <AppToolTip
                        enterTouchDelay={0}
                        title={`${withdrawData?.feeCharged?.rkflRate?.toString()} ${withdrawData?.feeCharged?.currency}`}
                        placement="top" arrow>
                        <span>{trimText(withdrawData?.feeCharged?.rkflRate?.toString(), 6)}</span>
                      </AppToolTip>&nbsp;{withdrawData?.feeCharged?.currency}

                    </Typography>
                  </Grid>
                </>
              )}
              {/* {!!withdrawData.reason && (
                <>
                  <Grid item xs={4}>
                    <Typography fontSize={14} fontWeight={400}>
                      {t("Reason")}:
                    </Typography>
                  </Grid>
                  <Grid item xs={8} textAlign="right">
                    <Typography fontSize={14} fontWeight={400}>
                      {withdrawData.reason}
                    </Typography>
                  </Grid>
                </>
              )} */}
              {/* <Grid item xs={4}>
                <Typography fontSize={14} fontWeight={400}>
                  {t("Hash")}
                </Typography>
              </Grid>
              <Grid item xs={8} textAlign="right">
                <div
                  style={{
                    whiteSpace: "nowrap",
                    width: "14rem",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <Typography fontSize={14} fontWeight={400}>
                    {withdrawData.hash || "---"}
                  </Typography>
                </div>
              </Grid> */}
            </Grid>
            <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
            {(!!withdrawData?.feeCharged?.payoutAmountCrypto || !!withdrawData?.feeCharged?.payoutAmount) && (
              <Box
                sx={{
                  display: "flex",
                  flexFlow: "row",
                  justifyContent: "space-between",
                  marginTop: 2,
                }}
              >
                <Typography fontSize={16} color="#F8FAFF">
                  {t("AmountReceived")}:
                </Typography>
                <Box>
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    sx={{ cursor: "pointer" }}
                  >
                    {!isFiatTransaction(withdrawData.service) && <Typography
                      fontSize={16}
                      fontWeight={700}
                      color="#F8FAFF"
                      textAlign={"right"}
                    >
                      {formatCryptoDecimals(
                        withdrawData.feeCharged.payoutAmountCrypto
                      )}{" "}
                      {withdrawData?.cryptoCurrency?.id}
                    </Typography>}
                    {isFiatTransaction(withdrawData.service) && <Typography
                      fontSize={16}
                      fontWeight={700}
                      color="#F8FAFF"
                      textAlign={"right"}
                    >
                      {formatNumber(
                        withdrawData.feeCharged.payoutAmount
                      )}{" "}
                      {withdrawData?.feeCharged?.currency}
                    </Typography>}&nbsp;&nbsp;
                    {!isFiatTransaction(withdrawData.service) && <AppToolTip
                      title={t("approxDisclaimer")}
                      arrow
                      enterTouchDelay={0}
                    >
                      <InfoOutlined style={{ color: '#ffffff' }} />
                    </AppToolTip>}
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
          {!!(withdrawData.type === TYPE_MERCHANT_RECLAIM) && (
            <Box>
              <Typography fontSize={16} fontWeight={400} padding={1}>
                {t("note")}: {t("contact-merchant-reclaim")}
              </Typography>
            </Box>

          )}
          {/* {withdrawData.descriptor && (
            <Box>
              <Typography fontSize={16} fontWeight={400} padding={1}>
                {withdrawData.descriptor}
              </Typography>
            </Box>
          )} */}
          <AppButton
            disableElevation
            startIcon={<Home />}
            title={t("BackDashboard")}
            onClick={() => navigate("/home")}
          />
        </Container>
      </ThemeProvider>
    </AppBaseScreen>
  );
}
